module.exports = __webpack_public_path__ + "media/couriers/dpd_logo-d7e38369.png";